__turbopack_context__.v({
  "back-button": "hybrid-page-chat-panel-module-scss-module__CWrXuq__back-button",
  "beta-badge": "hybrid-page-chat-panel-module-scss-module__CWrXuq__beta-badge",
  "chat-area": "hybrid-page-chat-panel-module-scss-module__CWrXuq__chat-area",
  "chip": "hybrid-page-chat-panel-module-scss-module__CWrXuq__chip",
  "chip-emoji": "hybrid-page-chat-panel-module-scss-module__CWrXuq__chip-emoji",
  "chip-label": "hybrid-page-chat-panel-module-scss-module__CWrXuq__chip-label",
  "clear-button": "hybrid-page-chat-panel-module-scss-module__CWrXuq__clear-button",
  "filter-chips-bar": "hybrid-page-chat-panel-module-scss-module__CWrXuq__filter-chips-bar",
  "header-left": "hybrid-page-chat-panel-module-scss-module__CWrXuq__header-left",
  "listings-button": "hybrid-page-chat-panel-module-scss-module__CWrXuq__listings-button",
  "mobile-toolbar": "hybrid-page-chat-panel-module-scss-module__CWrXuq__mobile-toolbar",
  "panel": "hybrid-page-chat-panel-module-scss-module__CWrXuq__panel",
  "panel-desktop": "hybrid-page-chat-panel-module-scss-module__CWrXuq__panel-desktop",
  "panel-header": "hybrid-page-chat-panel-module-scss-module__CWrXuq__panel-header",
  "panel-mobile": "hybrid-page-chat-panel-module-scss-module__CWrXuq__panel-mobile",
  "panel-open": "hybrid-page-chat-panel-module-scss-module__CWrXuq__panel-open",
  "panel-title": "hybrid-page-chat-panel-module-scss-module__CWrXuq__panel-title",
  "suggestion-chips": "hybrid-page-chat-panel-module-scss-module__CWrXuq__suggestion-chips",
  "toggle-active": "hybrid-page-chat-panel-module-scss-module__CWrXuq__toggle-active",
  "toggle-bar": "hybrid-page-chat-panel-module-scss-module__CWrXuq__toggle-bar",
  "toggle-button": "hybrid-page-chat-panel-module-scss-module__CWrXuq__toggle-button",
  "toggle-icon": "hybrid-page-chat-panel-module-scss-module__CWrXuq__toggle-icon",
});
